import alphalogo from "./logo/alphalogo.png";
import dhcgreportsLogo from "./logo/dhcgreportsLogo.png"
import dhcgreportsHeader from "./headers/HeaderImgs/dhcgreportsHeader.png"
import dhcgreportsFooter from "./footers/FooterImgs/dhcgreportsFooter.svg"
import reportsAlphalabsqatarLogo from "./logo/reportsAlphalabsqatarLogo.png"
import reportsAlphalabsqatarHeader from "./headers/HeaderImgs/reportsAlphalabsqatarHeader.svg"
import reportsAlphalabsqatarFooter from "./footers/FooterImgs/reportsAlphalabsqatarFooter.png"
import wiseMedicalCenterLogo from "./logo/wiseMedicalCenterLogo.png"
import wiseMedicalCenterHeader from "./headers/HeaderImgs/wiseMedicalCenterHeader.png"
import { WiseMedicalCenterFooter } from "./footers/FootersComponent"; 

export const defaultTenant = {
  logo: null,
  header: null,
  footerType: "NONE",
  footer: null,
};

export const siteConfig = {
  "dhcgreports.com": {
    logo: dhcgreportsLogo,
    header: dhcgreportsHeader,
    footerType: "IMAGE",
    footer: dhcgreportsFooter,
  },

  "reports.alphalabsqatar.com": {
    logo: reportsAlphalabsqatarLogo,
    header: reportsAlphalabsqatarHeader,
    footerType: "IMAGE",
    footer: reportsAlphalabsqatarFooter,
  },

  "wisemedical.magunex.com": {
    logo: wiseMedicalCenterLogo,
    header: wiseMedicalCenterHeader,
    footerType: "COMPONENT",
    footer: WiseMedicalCenterFooter,
  },
};
